import React, { useState } from 'react'
import { Input, Grid, Row, Col, Panel, RadioGroup, Radio } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'

export default function ProblemsAndSolutionForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isHaveProblem, setIsHaveProblem] = useState(schema.isProblemsEncountered.value)

  return (
    <Panel>
      <Grid fluid>
        <Row>
          <Controller
            key={schema.isProblemsEncountered.name}
            name={schema.isProblemsEncountered.name}
            control={control}
            defaultValue={schema.isProblemsEncountered.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  inline
                  onChange={(val) => {
                    props.onChange(val)

                    if (val == 0) {
                      setValue(schema.problems.name)
                      setValue(schema.solutions.name)
                    }
                    setIsHaveProblem(val)
                  }}
                >
                  {schema.isProblemsEncountered.options?.map((item) => {
                    return <Radio value={item.value}>{item.label}</Radio>
                  })}
                </RadioGroup>
              )
            }}
          />

          {isHaveProblem == 1 && (
            <>
              {/* {errors[schema.problems.name] && (
                <Row style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.problems.name]} />
                </Row>
              )} */}
              <Row style={{ marginTop: 10 }}>
                <CKEditorFrom
                  schema={schema.problems}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Row>
              {/* {schema.problems.label} */}
              {/* <Input
                  componentClass="textarea"
                  rows={3}
                  name={schema.problems.name}
                  defaultValue={schema.problems.value}
                  inputRef={register(isValidators(schema.problems.validators))}
                  placeholder={schema.problems.hint}
                /> */}

              {/* {errors[schema.solutions.name] && (
                <Row style={{ marginTop: 10 }}>
                  <ErrorMessage error={errors[schema.solutions.name]} />
                </Row>
              )} */}
              <Row style={{ marginTop: 10 }}>
                <CKEditorFrom
                  schema={schema.solutions}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <p>{schema.solutions.label}</p>
                <Input
                  componentClass="textarea"
                  rows={3}
                  name={schema.solutions.name}
                  defaultValue={schema.solutions.value}
                  inputRef={register(isValidators(schema.solutions.validators))}
                  placeholder={schema.solutions.hint}
                /> */}
              </Row>
            </>
          )}
        </Row>
      </Grid>
    </Panel>
  )
}
